/* WSH Collection Filter — Human / Vet toggle (handle-based exact mapping) */
(function(){
'use strict';

/* VET collections by handle (verified from product contents) */
var VET = [
  'alps-system','alps-implants','alps-surgical-kit','alps-instrument','alps-plate',
  'tplo-system','tplo-implants','tplo-surgical-kit','tplo-plate','tplo-series',
  'tta-system','tta-instrument-set','tta-implants','tta-surgical-kit','tta-instrument',
  'pgr-system','pgr-implants','pgr-instrument','pgr-surgical-kit',
  'spinal-system','vet-surgical-instruments','veterinary-bone-drills','vet-products',
  'basic-instrument','basic-instrument-set','basic-implants','bone-plate',
  'plates-screws','bone-plates-screws','screw','screw-kit','general-instruments',
  'externa-fixator-system','externa-fixator-instrument-set','externa-fixator-implants','external-fixation-device',
  'suture-anchors','suture-anchors-implants','suture-anchors-instrument-set','accessories'
];

/* HUMAN collections by handle */
var HUMAN = [
  'thr-system','thr-implants','thr-surgical-kit','thr-instrument',
  'cmf-system','cmf-instrument-set','cmf-implants','cmf','cmf-instruments',
  'clavicle','humerus','metacarpals-phalanges','radius-ulna','femur','fibula','foot-ankle',
  'patella','pelvis','tibia','ribs','radius-ulna-1','shoulder-joint','knee-joint',
  'finger-wrist-joints','foot-ankle-joint',
  'thoracolumbar-fusion','anterior-cervical-fusion','posterior-cervical-fusion','spine',
  'spinal-implants','spinal-instrument-set-no-implant','spinal-system-instrument',
  'spinal-screw-rod-system','minimally-invasive-spinal-system','neuro',
  'maxillofacial-plastic-plate-system','maxillofical-locking-plate-system',
  'maxillofacial-reconstruction-plate','maxillofacial-reconstruction-locking-plate',
  'orthognathic-plate-system','titanium-mesh','interlink-plate','orbital','midface','mandible',
  'trauma','locking-plate-system','intramedullary-nail-system','joints-system',
  'sport-medicine','human-products'
];

function init(){
  var items=document.querySelectorAll('li.collection-filter');
  if(!items.length){setTimeout(init,500);return}

  var all=[];
  items.forEach(function(el){
    var name=(el.textContent||'').trim();
    var handle=(el.getAttribute('value')||'').trim().toLowerCase();
    var cat=null;
    if(VET.indexOf(handle)>=0)cat='vet';
    else if(HUMAN.indexOf(handle)>=0)cat='human';
    else if(VET.indexOf(name.toLowerCase())>=0)cat='vet';
    else if(HUMAN.indexOf(name.toLowerCase())>=0)cat='human';
    else if(/vet|alps|tplo|tta|pgr|canine|dog|animal/i.test(name))cat='vet';
    else if(/spine|femur|tibia|humerus|clavicle|mandible|cervical|cmf|thr|neuro|orbital|midface|knee|shoulder|ankle|trauma/i.test(name))cat='human';
    else cat='other';
    all.push({el:el,name:name,cat:cat});
  });

  var parent=items[0].closest('ul,div');
  if(!parent)parent=items[0].parentNode;

  var wrap=document.createElement('div');
  wrap.style.cssText='margin:0 0 8px 0;display:flex;gap:4px;padding:0';
  var makeBtn=function(t,m){
    var b=document.createElement('button');
    b.textContent=t;b.setAttribute('data-mode',m);
    b.style.cssText='padding:4px 10px;border:1px solid #36c;border-radius:4px;font-size:11px;cursor:pointer;font-weight:500;background:none;color:#36c;white-space:nowrap';
    return b;
  };
  var btnH=makeBtn('Human','human'),btnV=makeBtn('Veterinary','vet'),btnA=makeBtn('All','all');
  wrap.appendChild(btnH);wrap.appendChild(btnV);wrap.appendChild(btnA);
  parent.insertBefore(wrap,parent.firstChild);

  function setMode(m){
    [btnH,btnV,btnA].forEach(function(b){
      var active=b.dataset.mode===m;
      b.style.background=active?'#36c':'none';b.style.color=active?'#fff':'#36c';
    });
    all.forEach(function(item){
      item.el.style.display=(m==='all')?'':(m==='human'&&item.cat==='vet')?'none':(m==='vet'&&item.cat==='human')?'none':'';
    });
  }
  btnH.onclick=function(){setMode('human')};
  btnV.onclick=function(){setMode('vet')};
  btnA.onclick=function(){setMode('all')};
  setMode('human');
}

if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
else init();
})();
